export class PairwiseMap<K, V> {
	private relationships = new Map<K, Map<K, V>>()

	addPair(a: K, b: K, value: V) {
		const aMap = this.relationships.get(a) ?? new Map()
		const bMap = this.relationships.get(b) ?? new Map()
		aMap.set(b, value)
		bMap.set(a, value)
		this.relationships.set(a, aMap)
		this.relationships.set(b, bMap)
	}

	removePair(a: K, b: K) {
		if (!this.hasPair(a, b)) return
		this.relationships.get(a)?.delete(b)
		this.relationships.get(b)?.delete(a)
	}

	clear() {
		this.relationships.clear()
	}

	hasPair(a: K, b: K) {
		return this.relationships.get(a)?.has(b) ?? false
	}

	getValue(a: K, b: K) {
		return this.relationships.get(a)?.get(b)
	}

	getAllFor(a: K) {
		const aMap = this.relationships.get(a)
		if (!aMap) return []
		return Array.from(aMap.entries())
	}
}
